module.exports = __webpack_public_path__ + "img/image22.5dd6b7bb.png";